import { Specification } from "../../types";
import Heading from "../Heading";
import SpecificationCard from "./SpecificationCard";

interface Props {
  className?: string;
  includeHeading?: boolean;
  specifications: Specification[];
}

export const SpecificationList = ({
  className = "",
  includeHeading,
  specifications = [],
}: Props) => {
  return (
    <div className={`${className} flex flex-col h-full min-h-0`}>
      {/** Heading */}
      {includeHeading && (
        <div className="flex-shrink-0">
          <Heading
            className="flex flex-col justify-end items-end text-right pr-14"
            titleWordsClassName="justify-end"
            titleWords={[
              {
                content: "Car",
                colorGradient:
                  "linear-gradient(to right, rgba(56, 234, 245, 0.5), rgba(56, 234, 245, 1), rgba(56, 234, 245, 0.5))",
              },
              {
                content: "Specifications",
                colorGradient:
                  "linear-gradient(to right, rgba(196, 56, 245, 1), rgba(245, 56, 56, 0.5))",
              },
            ]}
            description="Lorem ipsum dolor sit amet consectetur adipiscing elit, sad de elisoum heyzdev temp indut."
          />
        </div>
      )}

      {/** Specifications */}
      <ul className="overflow-y-auto flex-1 min-h-0 space-y-4 my-5 1920px:my-10 pr-14 scrollbar-hide">
        {specifications?.map((spec) => (
          <li key={spec.name} className="w-full">
            <SpecificationCard className="w-full" specification={spec} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SpecificationList;
